<template>
  <router-view id="app" class="app__view"></router-view>
</template>

<script>
import 'vue-material/dist/vue-material.min.css';
import '@/assets/css/main.css';

export default {
  name: 'app',
  created() {
    document.title = this.$t('title');
  }
}
</script>

<style lang="scss">
@import url('https://use.fontawesome.com/releases/v5.11.1/css/all.css');
@import url('https://fonts.googleapis.com/css?family=Montserrat:200,400,600,800&display=swap&subset=latin-ext');

@import '@/assets/scss/_variables';
@import "~vue-material/dist/theme/engine";

@include md-register-theme(
  "default",
  (
    primary: $colorLight,
    accent: $colorMain
  )
);
@import "~vue-material/dist/theme/all";

body,
html {
  font-size: 12pt;
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @apply .leading-normal;
}

.header,
.map,
.sensor-details {
  min-width: $minW;

  @media (min-width: theme('screens.sm')) {
    min-width: 0;
  }
}

*:focus {
  outline: none !important;
}

#app {
  color: $colorText;

  input,
  textarea {
    font: inherit;
  }
}

.md-overlay {
  z-index: 10;
}

.md-menu-content-container .md-list {
  font-family: inherit;
}

.md-field label {
  font-size: inherit;
}

.md-button-content {
  @apply .inline-flex .text-xs .font-semibold;
}

img.h-full {
  @apply .h-full;
}

.color-quality {
  &-1 {
    color: $quality1;
  }

  &-2 {
    color: $quality2;
  }

  &-3 {
    color: $quality3;
  }

  &-4 {
    color: $quality4;
  }

  &-5 {
    color: $quality5;
  }

  &-6 {
    color: $quality6;
  }
}

.text-primary {
  color: $colorMain;
}

.text-primary-light {
  color: $colorLight;
}

.bg-primary-light {
  background-color: $colorLight;
}

.border-primary-light {
  border-color: $colorLight;
}

.vdatetime input {
  @apply .w-full .h-full;
  opacity: 0;
}

.theme-primary {
  .vdatetime-popup {
    font-family: inherit;
  }

  .vdatetime-popup__header,
  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: $colorMain;
  }

  .vdatetime-year-picker__item--selected,
  .vdatetime-time-picker__item--selected,
  .vdatetime-popup__actions__button {
    color: $colorMain;
  }
}
</style>
